export default {
  home: 'الصفحة الرئيسية',
  aboutUs: 'معلومات عنا',
  productsAndServices: 'المنتجات والخدمات',
  projectCases: 'حالات المشروع',
  contactUs: '📩 اتصل بنا',
  contactUs2: 'اتصل بنا',
  scrollDown: 'مرر لأسفل',
  companyName: 'شركة التناغم المحيطي التجاريةشركة التناغم المحيطي التجارية',
  companyIntro: 'مقدمة الشركة',
  brandStory: 'قصة العلامة التجارية',
  developmentHistory: 'التطور التاريخي',
  corporateCulture: 'ثقافة الشركة',
  qualificationsAndHonors: 'الشهادات والتكريمات',
  partners: 'شركاؤنا',
  customer: 'العميل',
  domesticNetwork: 'الشبكة المحلية',
  overseasNetwork: 'الشبكة الخارجية',
  businessOutlets: 'نقاط العمل',
  fullCategoryTransportService: 'خدمة النقل لجميع الفئات',
  oneStopSupplyChainService: 'خدمة سلسلة التوريد "الشاملة"',
  mainEngineeringMaterialsProducts: 'منتجات مواد الهندسة الرئيسية',
  logisticsBusiness: 'أعمال الخدمات اللوجستية',
  materialsBusiness: 'أعمال المواد',
  fullSupplyChainBusiness: 'أعمال سلسلة التوريد الكاملة',
  aboutOceanHarmony: 'تعرف على Ocean Harmony',
  historyAndEvolution: 'التطور التاريخي (2024 ~ حتى الآن)',
  companyHonors: 'تكريمات الشركة',
  address: 'العنوان',
  phone: 'الهاتف',
  email: 'البريد الإلكتروني',
  send: 'إرسال',
  weChatQRCode: 'رمز WeChat QR',
  scanToFollowUs: 'امسح للتواصل معنا',
  contact: 'ارسل استفسارك في أي وقت!',
  mondayToFriday: 'من الأحد إلى الخميس',
  leaveMessage: 'اترك رسالة',
  subject: 'الموضوع',
  nickname: 'الاسم المستعار',
  companyTopName: "Zhongcheng Group",
  transportation: "Zhongcheng Transport",
  copyright: "جميع الحقوق محفوظة",
  companyTopTitle: "ZCTS SHENZHEN CO., LTD.",
  projectDetail: 'تفاصيل المشروع',

  // 表单验证消息
  enterYourName: 'الرجاء إدخال اسمك',
  enterYourEmail: 'الرجاء إدخال بريدك الإلكتروني',
  enterYourPhone: 'الرجاء إدخال هاتفك',
  enterSubject: 'الرجاء إدخال الموضوع',
  enterMessageContent: 'الرجاء إدخال محتوى الرسالة',
  enterValidEmail: 'الرجاء إدخال عنوان بريد إلكتروني صالح',
  messageContentAtLeast10: 'يجب أن يكون محتوى الرسالة 10 أحرف على الأقل',
  nameLengthBetween2And30: 'يجب أن يكون طول الاسم بين 2 و 30 حرفًا',
  formSubmitSuccess: 'تم الإرسال بنجاح! شكراً لتواصلك معنا.',
  completeFormBeforeSubmitting: 'الرجاء استكمال معلومات النموذج قبل الإرسال',

  // 其他内容
  mainTilte: 'متخصصون في مجال مشاريع الهندسة، نقدم منتجات المواد الرئيسية التالية وفقًا لخصائص المشاريع الهندسية',
  ViewDetails: 'عرض التفاصيل',
  Loading: 'جار التحميل...',
  companyCoverage: "تغطي <span class=\"map-top\">&nbsp;13&nbsp;</span> شركة محلية المدن الساحلية الرئيسية على طول الطريق",
  businessOutletsTitle1: "أوشن هارموني لديها حالياً <span class='w-map-top'>&nbsp; 9 &nbsp;</span> نقاط عمل مباشرة في الخارج",
  businessOutletsTitle2: "أكثر من <span class='w-map-top'>&nbsp; 14 &nbsp;</span> عاماً من التواجد العميق في أفريقيا وجنوب شرق آسيا",
  qayimatAlmuntajat: "قائمة المنتجات",
  LanguageMessage: "تم تغيير اللغة بنجاح!",
    WHATSAPP:'واتساب'
};